import { CartItem } from 'models/CartItem';
import { PageState } from 'models/PageState';
import { Price } from 'models/Price';
import { isProductPage } from 'models/ProductPageModel';
import { createSelector, Selector } from 'reselect';
import { rm } from 'utils';

const selectRentalPrice: Selector<PageState, number> = ({ currentPage }): number => {
  const DEFAULT_VALUE = 0;
  if (!isProductPage(currentPage)) return DEFAULT_VALUE;
  const rentalPrice = currentPage.product.price.rentalPrice;
  if (!rentalPrice) return DEFAULT_VALUE;
  return rentalPrice;
};

export const hasRentalPriceSelector = createSelector(
  selectRentalPrice,
  rentalPrice => rentalPrice > 0
);

export const selectShowDeliveryInfo: Selector<PageState, boolean> = ({ currentPage }): boolean => {
  if (!isProductPage(currentPage)) return false;
  return currentPage.product.meta?.showDeliveryInfo ?? false;
};


type RentalPrice = Pick<CartItem, 'rentalPrice'> | Pick<Price, 'rentalPrice'>;

export const getIsRentalProduct = <T extends CartItem>(price: RentalPrice): price is T & Price => {
  return price?.rentalPrice !== undefined && price.rentalPrice > 0;
};

export const getRentalUnit = (item: CartItem): string | undefined => {
  const isRentalProduct = getIsRentalProduct(item);
  return isRentalProduct ? `&nbsp;${rm('checkout_unit')}${item.rentalUnit}` : undefined;
};

export const getPriceWithRent = (item: CartItem) => {
  const isRentalProduct = getIsRentalProduct(item);
  return isRentalProduct ? item.rentalPrice * item.quantity.amount : item.linePrice.amount;
};
